module.exports = __webpack_public_path__ + "static/media/red_circle.70ba0222.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/red_circle.png
// module id = 1130
// module chunks = 0